import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ngfModule } from 'angular-file';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { QuillModule } from 'ngx-quill';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import {
  PdfViewerModule, LinkAnnotationService, BookmarkViewService, MagnificationService, ThumbnailViewService,
  ToolbarService, NavigationService, TextSearchService, TextSelectionService, PrintService
} from '@syncfusion/ej2-angular-pdfviewer';

//Directive imports
import { PhoneFormatDirective } from './directive/phone-format.directive';
import { USZipFormatDirective } from './directive/uszip-format.directive';
import { TimeValidateDirective } from './directive/time-validate.directive';
import { PercentNumberDirective } from './directive/percent-number.directive';
import { CheckBoxYNDirective } from './directive/check-box-yn.directive';
import { ElasticDirective } from './directive/elastic.directive';
import { NavigableDirective } from './directive/navigable.directive';
import { SelectAllOnClickDirective } from './directive/select-all-on-click.directive';

//Pipe imports
import { ExcludeFromPipe } from './pipe/exclude-from.pipe';
import { OrderByPipe } from './pipe/order-by.pipe';
import { DOMSafePipe } from './pipe/domsafe.pipe';
import { DaysAndHoursPipe } from './pipe/days-and-hours.pipe';

//Component imports
import { SearchDropDownComponent } from './component/search-drop-down/search-drop-down.component';
import { FileUploadComponent } from './component/file-upload/file-upload.component';
import { MultipleDateSelectorComponent } from './component/multiple-date-selector/multiple-date-selector.component';
import { SsnFormatDirective } from './directive/ssn-format.directive';
import { FilereadDirective } from './directive/fileread.directive';
import { RichTextEditorComponent } from './component/rich-text-editor/rich-text-editor.component';
import { AutoCompleteEmailComponent } from './component/auto-complete-email/auto-complete-email.component';
import { CrewTimecardGridComponent } from './component/crew-timecard-grid/crew-timecard-grid.component';
import { TimeWorkedComponent } from './component/time-worked/time-worked.component';
import { AutoCompleteEmailTCBComponent } from './component/auto-complete-email-t-c-b/auto-complete-email-t-c-b.component';
import { CustomAutofocusDirective } from './directive/custom-autofocus.directive';
import { WebixDatatablecomponent } from './component/time-off-grid/webix-datatable.component';
import { HRIMPdfViewerComponent } from './component/pdf-viewer/pdf-viewer.component';
import { OrderByWithParsingPipe } from './pipe/order-by-with-parsing.pipe';
import { DateTwentyFourHoursDirective } from './directive/date-twenty-four-hours.directive';
import { ServiceManagerFilterComponent } from './component/service-manager-filter/service-manager-filter.component';
import { LoginFooterComponent } from './component/login-footer/login-footer.component';
import { ReadOnlyPdfViewerComponent } from './component/read-only-pdf-viewer/read-only-pdf-viewer.component';
import { OrderByAlphanumPipe } from './pipe/order-by-alphanum.pipe';
import { KeypressEventsComponent } from './component/keypress-events/keypress-events.component';


//Sort order for declarations/exports - Directives,Pipes,Components
@NgModule({
  declarations: [
    PhoneFormatDirective,
    USZipFormatDirective,
    TimeValidateDirective,
    PercentNumberDirective,
    CheckBoxYNDirective,
    ExcludeFromPipe,
    OrderByPipe,
    DOMSafePipe,
    DaysAndHoursPipe,
    SearchDropDownComponent,
    PercentNumberDirective,
    CheckBoxYNDirective,
    FileUploadComponent,
    SsnFormatDirective,
    MultipleDateSelectorComponent,
    FilereadDirective,
    RichTextEditorComponent,
    AutoCompleteEmailComponent,
    CrewTimecardGridComponent,
    TimeWorkedComponent,
    ElasticDirective,
    AutoCompleteEmailTCBComponent,
    CustomAutofocusDirective,
    WebixDatatablecomponent,
    HRIMPdfViewerComponent,
    NavigableDirective,
    SelectAllOnClickDirective,
    OrderByWithParsingPipe,
    ServiceManagerFilterComponent,
    DateTwentyFourHoursDirective,
    LoginFooterComponent,
    ReadOnlyPdfViewerComponent,
    OrderByAlphanumPipe,
    KeypressEventsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ngfModule,
    NgSelectModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    QuillModule,
    CollapseModule,
    NgbModule,
    PdfViewerModule
  ],
  exports: [
    PhoneFormatDirective,
    USZipFormatDirective,
    TimeValidateDirective,
    PercentNumberDirective,
    CheckBoxYNDirective,
    ElasticDirective,
    ExcludeFromPipe,
    OrderByPipe,
    DOMSafePipe,
    DaysAndHoursPipe,
    SearchDropDownComponent,
    PercentNumberDirective,
    CheckBoxYNDirective,
    FileUploadComponent,
    SsnFormatDirective,
    MultipleDateSelectorComponent,
    FilereadDirective,
    RichTextEditorComponent,
    AutoCompleteEmailComponent,
    CrewTimecardGridComponent,
    TimeWorkedComponent,
    AutoCompleteEmailTCBComponent,
    CustomAutofocusDirective,
    WebixDatatablecomponent,
    HRIMPdfViewerComponent,
    NavigableDirective,
    SelectAllOnClickDirective,
    OrderByWithParsingPipe,
    DateTwentyFourHoursDirective,
    ServiceManagerFilterComponent,
    LoginFooterComponent,
    ReadOnlyPdfViewerComponent,
    KeypressEventsComponent
  ],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, TextSearchService, TextSelectionService, PrintService]    
})
export class SharedModule { }
